/*  Shared  */
import { Response } from 'application/Shared/Helpers';
import Requests from 'application/Shared/Requests/Handler';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  Constants  */
const { hasData, getOne, getData } = Response;

class TenantApp {
    constructor(clientId) {
        this.requests = new Requests();
        this.clientId = clientId;
    }

    cancel = () => {
        this.requests.cancel();
    };

    getOne = async (p = {}) => {
        const params = p;

        if (this.clientId) {
            params.platformTenantId = this.clientId;
            params.includeClients = true;
        }

        try {
            const response = await axios.get('/tenantApp', {
                cancelToken: this.requests.token(),
                params
            });

            if (!hasData(response)) {
                return false;
            }

            return getOne(response);
        } catch (e) {
            debug.e('Unable to get Tenant Apps', e);
            return false;
        }
    };

    getAll = async (p = {}) => {
        const params = { ...p, size: -1 };

        if (this.clientId) {
            params.platformTenantId = this.clientId;
            params.includeClients = true;
        }

        try {
            const response = await axios.get('/tenantApp', {
                cancelToken: this.requests.token(),
                params
            });

            if (!hasData(response)) {
                return [];
            }

            return getData(response);
        } catch (e) {
            debug.e('Unable to get Tenant Apps', e);
            return [];
        }
    };
}

export default TenantApp;
